import { formatDistanceToNowStrict } from 'date-fns';

export const formatShortTime = (date: Date | string): string => {
  const d = new Date(date);
  const distance = formatDistanceToNowStrict(d);
  
  // Convert "21 hours" to "21h", "5 minutes" to "5m", etc.
  return distance
    .replace(' seconds', 's')
    .replace(' second', 's')
    .replace(' minutes', 'm')
    .replace(' minute', 'm')
    .replace(' hours', 'h')
    .replace(' hour', 'h')
    .replace(' days', 'd')
    .replace(' day', 'd')
    .replace(' months', 'mo')
    .replace(' month', 'mo')
    .replace(' years', 'y')
    .replace(' year', 'y');
};
